import { createReducer, on } from '@ngrx/store';
import * as IntegrationsActions from '@states/integrations/integrations.actions';
import { IntegrationsModel } from '@models/integrations.model';

export declare interface IntegrationsState {
  integrations: IntegrationsModel.Providers[];
  details: IntegrationsModel.IntegrationsBaseDocument;
  apiLimits: IntegrationsModel.ApiLimit[];
  vccLogAnalytics: IntegrationsModel.VccLogAnalytics;
  ccLogAnalytics: IntegrationsModel.CcLogAnalytics;
  apiLimitsHistory: IntegrationsModel.ApiLimitHistory;
}


export const initialState: IntegrationsState = {
  integrations: null,
  details: null,
  apiLimits: [],
  vccLogAnalytics: null,
  ccLogAnalytics: null,
  apiLimitsHistory: null,
};

export const integrationsStateReducer = createReducer(
  initialState,
  on(IntegrationsActions.resetToInitialState, state => {
    return {
      ...initialState,
    };
  }),
  on(IntegrationsActions.getIntegrationsSuccess, (state, { integrations }) => {
    return {
      ...state,
      integrations,
    };
  }),
  on(IntegrationsActions.getIntegrationDetailsSuccess, (state, { details }) => {
    return {
      ...state,
      details,
    };
  }),
  on(IntegrationsActions.updateIntegrationsQuotaSuccess, (state, { details }) => {
    return {
      ...state,
      details,
    };
  }),
  on(IntegrationsActions.uninstallGenea, (state) => {
    const integrations = state.integrations.filter(integration => integration !== IntegrationsModel.Providers.Genea);
    return {
      ...state,
      integrations,
    };
  }),
  on(IntegrationsActions.uninstallKisi, (state) => {
    const integrations = state.integrations.filter(integration => integration !== IntegrationsModel.Providers.Kisi);
    return {
      ...state,
      integrations,
    };
  }),
  on(IntegrationsActions.uninstallImmixSuccess, (state) => {
    const integrations = state.integrations.filter(integration => integration !== IntegrationsModel.Providers.Immix);
    const details = { ...state.details };
    if (details.providers?.immix) {
      delete details.providers.immix;
    }
    return {
      ...state,
      integrations,
      details,
    };
  }),
  on(IntegrationsActions.uninstallFlirSuccess, (state) => {
    const integrations = state.integrations.filter(integration => integration !== IntegrationsModel.Providers.Flir);
    const details = { ...state.details };
    if (details.providers?.flir) {
      delete details.providers.flir;
    }
    return {
      ...state,
      integrations,
      details,
    };
  }),
  on(IntegrationsActions.getApiLimitsSuccess, (state, { apiLimits }) => {
    return {
      ...state,
      apiLimits,
    };
  }),
  on(IntegrationsActions.getVccLogAnalyticsSuccess, (state, { vccLogAnalytics }) => {
    return {
      ...state,
      vccLogAnalytics,
    };
  }),
  on(IntegrationsActions.getCcLogAnalyticsSuccess, (state, { ccLogAnalytics }) => {
    return {
      ...state,
      ccLogAnalytics,
    };
  }),
  on(IntegrationsActions.getApiLimitsHistorySuccess, (state, { apiLimitsHistory }) => {
    return {
      ...state,
      apiLimitsHistory,
    };
  }),
);
